export default __webpack_public_path__ + "static/media/female_02.d9500124.png";